// Sunucudaki /uploads yolları ve tam adresler için ortak çözümleyici.
import api from "../api/api";

export const portalAssetUrl = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return "";
  if (/^(https?:|data:|blob:)/i.test(raw)) return raw;
  const base = String(api.defaults.baseURL || "").replace(/\/+$/, "");
  return `${base}${raw.startsWith("/") ? raw : `/${raw}`}`;
};

/** Menü renklerini CSS değişkenlerine çevirir (PortalHeader / PortalFooter). */
export const menuStyleVars = (portal) => {
  const m = portal?.theme?.menu || {};
  return {
    "--pm-topbar-bg": m.topBarBackground,
    "--pm-topbar-text": m.topBarText,
    "--pm-bg": m.background,
    "--pm-text": m.text,
    "--pm-active-bg": m.activeBackground,
    "--pm-active-text": m.activeText,
    "--pm-button-bg": m.buttonBackground,
    "--pm-button-text": m.buttonText,
  };
};
